<template>
  <Card>
    <h1 slot="Title">Fiscal Station Number (FSN) (021001)</h1>
    <div slot="MainContent">
      <p>
        Identifies the accounting office responsible for maintaining the accounting records of the allotment or allowance of funds. In GFEBS the FSN will be
        021001 (Defense Finance and Accounting Services or DFAS).
        <br>
        <br>
        <br>
      </p>
      <p>
        202011D20_ A76VV 131096QLOG 6100.2617 WBS, Internal Order or Cost Center 1000000067 <b><u>021001</u></b>
      </p>
    </div>
    <p><strong>Fiscal Station Number (FSN)</strong></p>
    <p>&nbsp;</p>
    <p><strong>Instructor/students go to 37-100&gt;2J-FSN</strong></p>
    <p><strong>FISCAL STATION NUMBER (FSN) (021001). </strong>The seventh element in the line of accounting is the Fiscal Station Number. A FSN is a five digit number (in a six position field) assigned to an installation or activity integrated finance and accounting office, or a non-integrated finance office, a fully supported activity, a decentralized accounting office, Pseudo Non Appropriated Fund Office (NAF), or a state department activity.&nbsp;&nbsp; It identifies the Operating Location that is responsible for maintaining the detailed accounting records for the allotment of funds. In GFEBS, the Fiscal Station number is <u><strong>021001</strong></u>.</p>
    <p>&nbsp;&nbsp;&nbsp;</p>
    <p>FSN= will always be the same (responsible for outgoing payments) DSSN and ADSN will be different depending on the location.</p>
    <p>&nbsp;</p>
    <p><strong>202011D13 A76VV76VV0065&nbsp; 6100.2617&nbsp; 131096QLOG Cost Center, WBS, or Internal Order 1000000067 </strong><strong>021001</strong></p> 
  </Card>
</template>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'Fiscal Station Number (FSN) (021001)',
  
  data() {
    return {
    }
  }
  
}
</script>